import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { AppButton, AppForm, AppText, FormInput } from "@/shared/Components";
import type { PhoneVerificationValues } from "../../model";
import { getPhoneVerifySchema, hidePhoneNumber } from "../../model";
import styles from "./styles.module.scss";

type Props = {
  onSubmit: (code: string) => void;
  getNewSms: () => void;
  errorMessage?: string;
  resendCoolDown: number;
  phoneNumber: string;
  smsSentCount: number;
};

export const PhoneVerificationForm = ({
  onSubmit,
  getNewSms,
  errorMessage,
  resendCoolDown,
  phoneNumber = "",
  smsSentCount,
}: Props) => {
  const { t } = useTranslation();
  const formApi = useForm({
    resolver: yupResolver(getPhoneVerifySchema()),
  });

  const handleSubmit = (data: PhoneVerificationValues) => {
    onSubmit(data.code);
  };

  const handleGetNewSms = () => {
    getNewSms();
  };

  useEffect(() => {
    if (errorMessage) {
      formApi.setError("code", { message: errorMessage });
    }
  }, [errorMessage]);

  return (
    <AppForm formApi={formApi} onSubmit={handleSubmit} className={styles["phone-verification"]}>
      <h1 className={styles.title}>
        {t("registrationPage.phoneVerifyStep.sentCode", {
          phoneNumber: hidePhoneNumber(phoneNumber),
        })}
      </h1>
      <FormInput
        placeholder={t("registrationPage.phoneVerifyStep.enterCode")}
        name="code"
        className={styles["registration-input"]}
      />
      <AppButton
        type="link"
        onClick={handleGetNewSms}
        disabled={resendCoolDown > 0 || smsSentCount >= 1}
        className={styles.resend}
      >
        {t("registrationPage.phoneVerifyStep.getNew")}
      </AppButton>
      <AppButton
        type="primary"
        htmlType="submit"
        className={styles.submit}
        disabled={!formApi.watch("code")}
      >
        {t("registrationPage.phoneVerifyStep.confirm")}
      </AppButton>
      {resendCoolDown > 0 && !(smsSentCount >= 1) && (
        <AppText type="secondary">
          {t("registrationPage.phoneVerifyStep.sending", {
            coolDown: resendCoolDown,
          })}
        </AppText>
      )}
    </AppForm>
  );
};
